export default __webpack_public_path__ + "static/media/retail.3f2c607c.svg";